const API_PATH = '/api/v1';
const WS_PATH = '/ws';

const trimTrailingSlashes = (value) => String(value || '').trim().replace(/\/+$/, '');

export const requireEnvironmentUrl = (name, value) => {
  const configured = String(value || '').trim();
  if (!configured) {
    throw new Error(
      `${name} is required. Define it in .env and restart the development server.`,
    );
  }

  return configured;
};

export const normalizeApiBaseUrl = (value) => {
  const configured = trimTrailingSlashes(value);
  if (!configured) return '';

  if (/\/api\/v1$/i.test(configured)) return configured;
  if (/\/api$/i.test(configured)) return `${configured}/v1`;

  return `${configured}${API_PATH}`;
};

export const normalizeWebSocketUrl = (value) => {
  const configured = trimTrailingSlashes(value)
    .replace(/^https:/i, 'wss:')
    .replace(/^http:/i, 'ws:');
  if (!configured) return '';

  // REACT_APP_WS_URL conventionally contains the complete endpoint. Only add
  // /ws when an origin (without a path) was supplied.
  try {
    const parsed = new URL(configured);
    if (!parsed.pathname || parsed.pathname === '/') {
      parsed.pathname = WS_PATH;
      return trimTrailingSlashes(parsed.toString());
    }
  } catch {
    // A relative development value is still useful; normalize it below.
  }

  return configured;
};

const configuredApiBaseUrl = requireEnvironmentUrl(
  'REACT_APP_API_BASE_URL',
  process.env.REACT_APP_API_BASE_URL,
);
const configuredWebSocketUrl = requireEnvironmentUrl(
  'REACT_APP_WS_URL',
  process.env.REACT_APP_WS_URL,
);

export const API_BASE_URL = normalizeApiBaseUrl(configuredApiBaseUrl);
export const WS_BASE_URL = normalizeWebSocketUrl(configuredWebSocketUrl);

// Explicit aliases make intent clear for callers that treat the WebSocket
// value as a complete endpoint rather than an origin.
export const WS_URL = WS_BASE_URL;
export { API_PATH, WS_PATH };
